
























































































import { computed, defineComponent, onBeforeUnmount, ref, watch } from '@nuxtjs/composition-api';
import { useProductContext } from '~/features/productContext';
import '~/assets/css/magiczoom.css';

export default defineComponent({
  name: 'ProductPageGallery',
  props: {
    isProductModal: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { product } = useProductContext();
    const selected = ref(product.value?.media_gallery?.[0]);
    const selectedIndex = ref<number | null>(0);
    const selectedImage = ref('');
    const openGalleryView = ref(false);

    onBeforeUnmount(() => {
      if (process.browser && (window as any).MagicZoom) {
        // Stop all Magic Zoom instances on the page before unmount
        (window as any).MagicZoom.stop();
      }
    });

    const items = computed((): (typeof selected['value'] & { index: number })[] => {
      return (
        product.value?.media_gallery
          ?.filter(img => !img?.disabled)
          .sort((a: any, b: any) => (a.position || Number.MAX_VALUE) - (b.position || Number.MAX_VALUE))
          .map((item, index) => ({ ...item, index })) ?? []
      );
    });

    watch(product, value => {
      selected.value = value.media_gallery?.[0];
    });

    function onClick(item: typeof selected['value'] & { index: number }) {
      selected.value = item;
      selectedIndex.value = item.index;
    }

    function onClickGalleryImage(selected: any) {
      selectedIndex.value = items.value?.indexOf(selected) || 0;
      selectedImage.value = selected.url;
      openGalleryView.value = true;
    }

    function swipeNext() {
      selectedIndex.value = Math.min(
        Math.max((selectedIndex.value || 0) + 1, 1),
        (items.value && items?.value?.length) - 1
      );

      selected.value = items.value?.[selectedIndex.value] as typeof selected['value'] & { index: number };
      selectedImage.value = selected.value.url || '';
    }

    function swipePrev() {
      selectedIndex.value = Math.min(Math.max((selectedIndex.value || 1) - 1, 0), items?.value?.length - 1);
      selected.value = items.value?.[selectedIndex.value] as typeof selected['value'] & { index: number };
      selectedImage.value = selected.value.url || '';
    }

    function swipeHandler(itemIndex: number) {
      selectedIndex.value = itemIndex;
      selected.value = items.value[itemIndex] as typeof selected['value'] & { index: number };
    }

    /**
     * ! Don't wrap this in onMounted, as it will search for the element before it's rendered by the slider
     */
    function handleSliderLoaded() {
      if (process.browser && (window as any).MagicZoom) {
        (window as any).MagicZoom.refresh();
      }
    }

    return {
      items,
      selected,
      onClick,
      product,
      selectedImage,
      selectedIndex,
      openGalleryView,
      onClickGalleryImage,
      swipeNext,
      swipePrev,
      swipeHandler,
      handleSliderLoaded,
    };
  },
});
